export const translations = {
  en: {
    // Navbar
    nav_home: "HOME",
    nav_labs: "LABS",
    nav_leadership: "LEADERSHIP",
    nav_why_pick_us: "WHY PICK US",
    nav_upcoming_tech: "UPCOMING TECHNOLOGIES",
    nav_about: "ABOUT",
    nav_services: "SERVICES",
    nav_projects: "PROJECTS",
    nav_contact: "CONTACT",

    // HaloNav UI
    nav_search: "SEARCH",
    nav_search_placeholder: "SEARCH PAGES, SECTIONS, SERVICES...",
    nav_esc: "ESC",
    nav_results: "RESULTS",
    nav_quick_nav: "QUICK NAVIGATION",
    nav_no_results: "NO RESULTS FOUND",
    nav_get_in_touch: "GET IN TOUCH →",
    nav_location: "LOCATION",
    nav_socials: "SOCIALS",
    
    // HaloNav Descriptions
    nav_desc_home: "MAIN LANDING PAGE",
    nav_desc_labs: "EXPERIMENTAL R&D DIVISION",
    nav_desc_leadership: "MEET OUR CORE LEADERSHIP TEAM",
    nav_desc_projects: "OUR CLIENT WORK PORTFOLIO",
    nav_desc_about: "WHO WE ARE AND WHAT WE DO",
    nav_desc_contact: "SEND US A MESSAGE",
    nav_desc_services: "CAPABILITIES & TECHNOLOGY STACK",
    nav_desc_system: "SCALABLE BACKEND ARCHITECTURE",
    nav_desc_interface: "UI/UX & FRONTEND DEVELOPMENT",
    nav_desc_strategy: "BRAND & DIGITAL CONSULTING",
    
    nav_type_page: "page",
    nav_type_section: "section",
    nav_type_service: "service",
    
    // Hero
    hero_tagline: "Digital Reality",
    hero_est: "Est. 2026",
    hero_studio_overview: "STUDIO OVERVIEW",
    hero_digital_studio: "DIGITAL STUDIO",
    hero_established: "ESTABLISHED",
    hero_location: "LOCATION",
    hero_focus: "FOCUS",
    hero_digital_architecture: "DIGITAL ARCHITECTURE",
    hero_intentional_design: "INTENTIONAL DESIGN •",

    // About
    about_our: "OUR",
    about_dna: "DNA.",
    about_tab_bio: "BIO DATA",
    about_tab_tech: "TECHNOLOGY",
    about_agency_profile: "AGENCY PROFILE",
    about_infra_spec: "INFRASTRUCTURE SPEC",
    about_specs: "SPECIFICATIONS",
    about_focus_lbl: "FOCUS",
    about_focus_val: "DIGITAL PRODUCT PLATFORMS",
    about_aesthetic_lbl: "AESTHETIC",
    about_aesthetic_val: "BRUTALIST / ARCHITECTURAL",
    about_location_lbl: "LOCATION",
    about_location_val: "LOS ANGELES, CA",
    about_footprint_lbl: "OUR FOOTPRINT",
    about_footprint_val: "ALL DIGITAL PRODUCTS AND PHYSICAL HARDWARE DEPLOYMENTS ARE EXECUTED ACCORDING TO THE HIGHEST PERFORMANCE STANDARDS. FROM BARE-METAL SERVERS AND RESTAURANT KIOSKS TO FULL-STACK WEB PLATFORMS AND ROBUST DATABASES, OUR ARCHITECTURE IS BUILT FOR RAPID SCALING. WE TAKE GREAT PRIDE IN ENGINEERING COMPLETE SOLUTIONS FROM THE GROUND UP.",
    about_software_lbl: "SOFTWARE ENGINE",
    about_frontend_lbl: "FRONTEND",
    about_frontend_val: "REACT / NEXT.JS / JAVASCRIPT / TYPESCRIPT",
    about_backend_lbl: "BACKEND",
    about_backend_val: "NODE.JS / EXPRESS / PYTHON / DOCKER",
    about_databases_lbl: "DATABASES",
    about_databases_val: "POSTGRESQL / SUPABASE / MONGODB / FIREBASE",
    about_infra_lbl: "INFRASTRUCTURE",
    about_hardware_lbl: "HARDWARE",
    about_hardware_val: "BARE-METAL SERVER DEPLOYMENTS / RESTAURANT KIOSK INTEGRATIONS",
    about_aesthetics_lbl: "AESTHETICS",
    about_aesthetics_val: "TAILWIND CSS / STRICT GRID ARCHITECTURE / FRAMER MOTION",

    // Services
    services_header: "Capabilities",
    service_art_title: "Art Direction",
    service_art_highlight: "Art",
    service_art_desc: "Crafting visual languages that communicate before a single word is read. We blend cinematic theory with digital interface design.",
    service_art_caps: "Visual Systems,Motion Design,3D Asset Creation,Cinematic Theory",
    service_webgl_title: "WebGL Worlds",
    service_webgl_highlight: "Worlds",
    service_webgl_desc: "Moving beyond the DOM. We build immersive, physics-based 3D environments that run smoothly in the browser.",
    service_webgl_caps: "React Three Fiber,GLSL Shaders,Physics Engines,Particle Systems",
    service_system_title: "System Architecture",
    service_system_highlight: "Architecture",
    service_system_desc: "Robust, scalable backends designed for high-performance applications. We ensure your infrastructure creates no friction.",
    service_system_caps: "Node.js / Python,Database Design,API Development,Cloud Infrastructure",
    service_brand_title: "Brand Identity",
    service_brand_highlight: "Identity",
    service_brand_desc: "Forging identities that command attention in a crowded digital landscape. Strategic, bold, and timeless.",
    service_brand_caps: "Strategy,Typography,Nomenclature,Market Positioning",

    // Capabilities specific
    cap_vision: "WE ENGINEER SCALABLE PLATFORMS FOR BOLD THINKERS WHO SEE TECHNOLOGY AS A CATALYST FOR CHANGE. FROM PHYSICAL KIOSKS TO ROBUST DATABASES, OUR ARCHITECTURE IS BUILT TO LAST AND MADE TO MATTER.",
    cap_partner: "PARTNER WITH US",
    cap_tab_services: "SERVICES",
    cap_tab_technology: "TECHNOLOGY",
    cap_spec: "CAPABILITIES SPECIFICATION",
    cap_engage: "ENGAGE",

    cap_srv_proto_lbl: "PROTOCOL",
    cap_srv_proto_tit: "SYSTEM DESIGN",
    cap_srv_proto_desc: "ARCHITECTING SCALABLE, HIGH-PERFORMANCE DIGITAL INFRASTRUCTURES DESIGNED TO WITHSTAND MODERN ENTERPRISE DEMANDS.",
    
    cap_srv_int_lbl: "INTERFACE",
    cap_srv_int_tit: "WEBSITES & APPS",
    cap_srv_int_desc: "DEVELOPING IMMERSIVE, GROUNDBREAKING WEB PLATFORMS AND FULL-STACK APPLICATIONS FROM THE GROUND UP.",

    cap_srv_hard_lbl: "HARDWARE",
    cap_srv_hard_tit: "RESTAURANT KIOSKS",
    cap_srv_hard_desc: "DEPLOYING PHYSICAL POINT-OF-SALE KIOSKS INTEGRATED WITH CUSTOM SOFTWARE AND SECURE PAYMENT GATEWAYS.",

    cap_tech_front_lbl: "FRONTEND",
    cap_tech_front_tit: "REACT & NEXT",
    cap_tech_front_desc: "BUILDING LIGHTNING-FAST, SERVER-SIDE RENDERED APPLICATIONS AND DYNAMIC SINGLE PAGE ARCHITECTURE.",

    cap_tech_infra_lbl: "INFRASTRUCTURE",
    cap_tech_infra_tit: "SERVER BUILDS",
    cap_tech_infra_desc: "PROVISIONING AND DEPLOYING BARE-METAL LINUX SERVERS, DOCKER CONTAINERS, AND CLOUD NETWORKS.",

    cap_tech_db_lbl: "DATABASES",
    cap_tech_db_tit: "NOSQL & SQL",
    cap_tech_db_desc: "ARCHITECTING RELATIONAL POSTGRESQL AND MONGODB DATABASES FOR HIGH AVAILABILITY AND SCALABLE DATA STORAGE.",

    // Projects UI
    projects_title_prefix: "SELECTED",
    projects_title_highlight: "WORKS",
    projects_view_all: "View All Projects (Archive)",
    project_loading: "Detailed case study content loading...",
    project_tech: "Technology",
    project_visit: "Visit Live Site",
    projects_selected_work: "/// SELECTED WORK",
    projects_clients: "CLIENTS",
    projects_our: "OUR",
    projects_work: "WORK.",
    projects_open_in_new_tab: "OPEN IN NEW TAB",
    projects_loading_interface: "LOADING INTERFACE...",
    projects_mission: "MISSION",
    projects_execution: "EXECUTION",

    // Contact
    contact_l1_p1: "LET'S",
    contact_l1_h1: "START",
    contact_l1_p2: "A",
    contact_l2_h1: "CONVERSATION.",
    contact_name_label: "Name",
    contact_name_placeholder: "Enter your name",
    contact_email_label: "Email",
    contact_email_placeholder: "name@example.com",
    contact_message_label: "Message",
    contact_message_placeholder: "Tell me about your project...",
    contact_btn_send: "Send Message",
    contact_btn_sending: "Sending...",
    contact_success_msg: "Message sent successfully. I'll get back to you soon.",
    contact_heading: "LOOKING FOR A DIGITAL PARTNER WHO UNDERSTANDS YOUR WORLD?",
    contact_lets_talk: "LET'S TALK",
    contact_your_name: "YOUR NAME",
    contact_your_email: "YOUR EMAIL",
    contact_your_message: "YOUR MESSAGE",
    contact_btn_sending_upper: "SENDING...",
    contact_btn_send_upper: "SEND MESSAGE",
    contact_success_upper: "TRANSMISSION REGISTERED ● INITIALIZING AI PORTAL...",
    contact_error_upper: "FAILED TO SEND",

    // Footer
    footer_rights: "ALL RIGHTS RESERVED.",
    footer_systems_online: "SYSTEMS ONLINE",
    footer_studio_location: "DIGITAL STUDIO — LOS ANGELES, CA",
    footer_description: "High-performance digital architecture. Systems designed for scale, precision, and extreme aesthetic impact.",
    footer_status_optimal: "ENG_STATUS: OPTIMAL",
    footer_dir: "DIRECTORY",
    footer_eng: "ENGAGEMENT",
    footer_pro: "PROTOCOLS",
    footer_sys_arch: "SYSTEMS ARCHITECTURE",
    footer_home: "Home",
    footer_labs: "Labs",
    footer_leadership: "Leadership",
    footer_about: "About",
    footer_privacy: "Privacy Policy",
    footer_terms: "Terms of Service",

    // Generic
    loading: "Loading...",

    // Upcoming Tech
    ut_upcoming: "Upcoming",
    ut_scroll: "Scroll to Explore",
    ut_footer: "The Future is Built Here.",
    
    ut_cloud_name: "Moratadeo Cloud",
    ut_cloud_tag: "Serverless Edge Infrastructure",
    ut_cloud_desc: "A globally distributed, auto-scaling runtime environment designed for zero-latency applications. Deploy code instantly to 300+ edge locations with no cold starts, intrinsic security, and infinite scalability.",
    
    ut_db_name: "Moratadeo DB",
    ut_db_tag: "Hyper-Consistent Data Fabric",
    ut_db_desc: "The world's first multi-model database with causal consistency at lightspeed. ACID transactions across regions, built-in vector search for AI agents, and a schema that evolves with your code.",

    // Leadership
    leadership_our: "OUR",
    leadership_team: "TEAM.",
    leadership_title: "LEADERSHIP",
    leadership_member: "MEMBER_",
    leadership_view_profile: "VIEW PROFILE ↗",
    leadership_name_label: "NAME",
    leadership_role_label: "ROLE",
    leadership_about_label: "ABOUT",
    
    // Leadership Roles & Bios
    leadership_role_ceo: "CHIEF EXECUTIVE OFFICER",
    leadership_bio_ceo: "LEADING THE VISION FOR MODERN DIGITAL PRODUCTS AND ARCHITECTURAL EXCELLENCE.",
    leadership_role_coo: "CHIEF OPERATING OFFICER",
    leadership_bio_coo: "DRIVING OPERATIONAL STRATEGY AND ENSURING THE HIGHEST STANDARDS OF PROJECT DELIVERY.",
    leadership_role_hod: "HEAD OF DESIGN",
    leadership_bio_hod: "DIRECTING THE DESIGN PHILOSOPHY AND CREATING HIGH-PERFORMANCE USER INTERFACES.",
  },
  es: {
    // Navbar
    nav_home: "INICIO",
    nav_labs: "LABORATORIOS",
    nav_leadership: "LIDERAZGO",
    nav_why_pick_us: "POR QUÉ ELEGIRNOS",
    nav_upcoming_tech: "TECNOLOGÍAS FUTURAS",
    nav_about: "SOBRE MÍ",
    nav_services: "SERVICIOS",
    nav_projects: "PROYECTOS",
    nav_contact: "CONTACTO",

    // HaloNav UI
    nav_search: "BUSCAR",
    nav_search_placeholder: "BUSCAR PÁGINAS, SECCIONES, SERVICIOS...",
    nav_esc: "ESC",
    nav_results: "RESULTADOS",
    nav_quick_nav: "NAVEGACIÓN RÁPIDA",
    nav_no_results: "NO SE ENCONTRARON RESULTADOS",
    nav_get_in_touch: "PONTE EN CONTACTO →",
    nav_location: "UBICACIÓN",
    nav_socials: "REDES SOCIALES",

    // HaloNav Descriptions
    nav_desc_home: "PÁGINA PRINCIPAL",
    nav_desc_labs: "DIVISIÓN EXPERIMENTAL DE I+D",
    nav_desc_leadership: "CONOCE A NUESTRO EQUIPO",
    nav_desc_projects: "NUESTRO PORTAFOLIO DE CLIENTES",
    nav_desc_about: "QUIÉNES SOMOS Y QUÉ HACEMOS",
    nav_desc_contact: "ENVÍANOS UN MENSAJE",
    nav_desc_services: "CAPACIDADES Y TECNOLOGÍA",
    nav_desc_system: "ARQUITECTURA BACKEND ESCALABLE",
    nav_desc_interface: "DESARROLLO FRONTEND Y UI/UX",
    nav_desc_strategy: "CONSULTORÍA DIGITAL Y DE MARCA",

    nav_type_page: "página",
    nav_type_section: "sección",
    nav_type_service: "servicio",
    
    // Hero
    hero_tagline: "Realidad Digital",
    hero_est: "Est. 2026",
    hero_studio_overview: "RESUMEN DEL ESTUDIO",
    hero_digital_studio: "ESTUDIO DIGITAL",
    hero_established: "ESTABLECIDO",
    hero_location: "UBICACIÓN",
    hero_focus: "ENFOQUE",
    hero_digital_architecture: "ARQUITECTURA DIGITAL",
    hero_intentional_design: "DISEÑO INTENCIONAL •",

    // About
    about_our: "NUESTRO",
    about_dna: "ADN.",
    about_tab_bio: "BIO DATOS",
    about_tab_tech: "TECNOLOGÍA",
    about_agency_profile: "PERFIL DE LA AGENCIA",
    about_infra_spec: "ESPECIFICACIONES DE INFRAESTRUCTURA",
    about_specs: "ESPECIFICACIONES",
    about_focus_lbl: "ENFOQUE",
    about_focus_val: "PLATAFORMAS DE PRODUCTOS DIGITALES",
    about_aesthetic_lbl: "ESTÉTICA",
    about_aesthetic_val: "BRUTALISTA / ARQUITECTÓNICA",
    about_location_lbl: "UBICACIÓN",
    about_location_val: "LOS ÁNGELES, CA",
    about_footprint_lbl: "NUESTRA HUELLA",
    about_footprint_val: "TODOS LOS PRODUCTOS DIGITALES Y DESPLIEGUES DE HARDWARE FÍSICO SE EJECUTAN SEGÚN LOS MÁS ALTOS ESTÁNDARES DE RENDIMIENTO. DESDE SERVIDORES BARE-METAL Y KIOSCOS DE RESTAURANTE HASTA PLATAFORMAS WEB FULL-STACK Y BASES DE DATOS ROBUSTAS, NUESTRA ARQUITECTURA ESTÁ CONSTRUIDA PARA UN ESCALADO RÁPIDO. NOS ENORGULLECE INGENIAR SOLUCIONES COMPLETAS DESDE CERO.",
    about_software_lbl: "MOTOR DE SOFTWARE",
    about_frontend_lbl: "FRONTEND",
    about_frontend_val: "REACT / NEXT.JS / JAVASCRIPT / TYPESCRIPT",
    about_backend_lbl: "BACKEND",
    about_backend_val: "NODE.JS / EXPRESS / PYTHON / DOCKER",
    about_databases_lbl: "BASES DE DATOS",
    about_databases_val: "POSTGRESQL / SUPABASE / MONGODB / FIREBASE",
    about_infra_lbl: "INFRAESTRUCTURA",
    about_hardware_lbl: "HARDWARE",
    about_hardware_val: "DESPLIEGUES DE SERVIDORES BARE-METAL / INTEGRACIONES DE KIOSCOS DE RESTAURANTE",
    about_aesthetics_lbl: "ESTÉTICA",
    about_aesthetics_val: "TAILWIND CSS / ARQUITECTURA DE CUADRÍCULA ESTRICTA / FRAMER MOTION",

    // Services
    services_header: "Capacidades",
    service_art_title: "Dirección de Arte",
    service_art_highlight: "Arte",
    service_art_desc: "Creando lenguajes visuales que comunican antes de leer una sola palabra. Combinamos teoría cinematográfica con diseño de interfaces digitales.",
    service_art_caps: "Sistemas Visuales,Diseño de Movimiento,Creación de Activos 3D,Teoría Cinematográfica",
    service_webgl_title: "Mundos WebGL",
    service_webgl_highlight: "Mundos",
    service_webgl_desc: "Más allá del DOM. Construimos entornos 3D inmersivos basados en física que funcionan fluidamente en el navegador.",
    service_webgl_caps: "React Three Fiber,Shaders GLSL,Motores de Física,Sistemas de Partículas",
    service_system_title: "Arquitectura de Sistemas",
    service_system_highlight: "Sistemas",
    service_system_desc: "Backends robustos y escalables diseñados para aplicaciones de alto rendimiento. Aseguramos que su infraestructura no cree fricción.",
    service_system_caps: "Node.js / Python,Diseño de Bases de Datos,Desarrollo de API,Infraestructura Cloud",
    service_brand_title: "Identidad de Marca",
    service_brand_highlight: "Identidad",
    service_brand_desc: "Forjando identidades que captan la atención en un paisaje digital abarrotado. Estratégico, audaz y atemporal.",
    service_brand_caps: "Estrategia,Tipografía,Nomenclatura,Posicionamiento de Mercado",

    // Capabilities specific
    cap_vision: "INGENIAMOS PLATAFORMAS ESCALABLES PARA PENSADORES AUDACES QUE VEN LA TECNOLOGÍA COMO UN CATALIZADOR DEL CAMBIO. DESDE KIOSCOS FÍSICOS HASTA BASES DE DATOS ROBUSTAS, NUESTRA ARQUITECTURA ESTÁ CONSTRUIDA PARA DURAR Y HECHA PARA IMPORTAR.",
    cap_partner: "COLABORA CON NOSOTROS",
    cap_tab_services: "SERVICIOS",
    cap_tab_technology: "TECNOLOGÍA",
    cap_spec: "ESPECIFICACIÓN DE CAPACIDADES",
    cap_engage: "INVOLUCRAR",

    cap_srv_proto_lbl: "PROTOCOLO",
    cap_srv_proto_tit: "DISEÑO DE SISTEMAS",
    cap_srv_proto_desc: "ARQUITECTANDO INFRAESTRUCTURAS DIGITALES ESCALABLES Y DE ALTO RENDIMIENTO DISEÑADAS PARA SOPORTAR LAS DEMANDAS EMPRESARIALES MODERNAS.",
    
    cap_srv_int_lbl: "INTERFAZ",
    cap_srv_int_tit: "SITIOS WEB Y APPS",
    cap_srv_int_desc: "DESARROLLANDO PLATAFORMAS WEB INMERSIVAS E INNOVADORAS Y APLICACIONES FULL-STACK DESDE CERO.",

    cap_srv_hard_lbl: "HARDWARE",
    cap_srv_hard_tit: "KIOSCOS DE RESTAURANTE",
    cap_srv_hard_desc: "DESPLEGANDO KIOSCOS FÍSICOS DE PUNTO DE VENTA INTEGRADOS CON SOFTWARE PERSONALIZADO Y PASARELAS DE PAGO SEGURAS.",

    cap_tech_front_lbl: "FRONTEND",
    cap_tech_front_tit: "REACT Y NEXT",
    cap_tech_front_desc: "CONSTRUYENDO APLICACIONES ULTRA RÁPIDAS CON RENDERIZADO DEL LADO DEL SERVIDOR Y ARQUITECTURA DINÁMICA DE PÁGINA ÚNICA.",

    cap_tech_infra_lbl: "INFRAESTRUCTURA",
    cap_tech_infra_tit: "CONSTRUCCIÓN DE SERVIDORES",
    cap_tech_infra_desc: "PROVISIONAMIENTO Y DESPLIEGUE DE SERVIDORES LINUX BARE-METAL, CONTENEDORES DOCKER Y REDES EN LA NUBE.",

    cap_tech_db_lbl: "BASES DE DATOS",
    cap_tech_db_tit: "NOSQL Y SQL",
    cap_tech_db_desc: "ARQUITECTANDO BASES DE DATOS RELACIONALES POSTGRESQL Y MONGODB PARA ALTA DISPONIBILIDAD Y ALMACENAMIENTO DE DATOS ESCALABLE.",

    // Projects UI
    projects_title_prefix: "TRABAJOS",
    projects_title_highlight: "SELECCIONADOS",
    projects_view_all: "Ver Todos (Archivo)",
    project_loading: "Cargando contenido detallado...",
    project_tech: "Tecnología",
    project_visit: "Visitar Sitio",
    projects_selected_work: "/// TRABAJO SELECCIONADO",
    projects_clients: "CLIENTES",
    projects_our: "NUESTRO",
    projects_work: "TRABAJO.",
    projects_open_in_new_tab: "ABRIR EN NUEVA PESTAÑA",
    projects_loading_interface: "CARGANDO INTERFAZ...",
    projects_mission: "MISIÓN",
    projects_execution: "EJECUCIÓN",

    // Contact
    contact_l1_p1: "VAMOS A",
    contact_l1_h1: "INICIAR",
    contact_l1_p2: "UNA",
    contact_l2_h1: "CONVERSACIÓN.",
    contact_name_label: "Nombre",
    contact_name_placeholder: "Ingresa tu nombre",
    contact_email_label: "Correo",
    contact_email_placeholder: "nombre@ejemplo.com",
    contact_message_label: "Mensaje",
    contact_message_placeholder: "Cuéntame sobre tu proyecto...",
    contact_btn_send: "Enviar Mensaje",
    contact_btn_sending: "Enviando...",
    contact_success_msg: "Mensaje enviado con éxito. Te responderé pronto.",
    contact_heading: "¿BUSCAS UN SOCIO DIGITAL QUE ENTIENDA TU MUNDO?",
    contact_lets_talk: "HABLEMOS",
    contact_your_name: "TU NOMBRE",
    contact_your_email: "TU CORREO",
    contact_your_message: "TU MENSAJE",
    contact_btn_sending_upper: "ENVIANDO...",
    contact_btn_send_upper: "ENVIAR MENSAJE",
    contact_success_upper: "TRANSMISIÓN REGISTRADA ● INICIALIZANDO PORTAL DE IA...",
    contact_error_upper: "ERROR AL ENVIAR",

    // Footer
    footer_rights: "TODOS LOS DERECHOS RESERVADOS.",
    footer_systems_online: "SISTEMAS EN LÍNEA",
    footer_studio_location: "ESTUDIO DIGITAL — LOS ÁNGELES, CA",
    footer_description: "Arquitectura digital de alto rendimiento. Sistemas diseñados para escala, precisión y extremo impacto estético.",
    footer_status_optimal: "ESTADO_ING: ÓPTIMO",
    footer_dir: "DIRECTORIO",
    footer_eng: "INTERACCIÓN",
    footer_pro: "PROTOCOLOS",
    footer_sys_arch: "ARQUITECTURA DE SISTEMAS",
    footer_home: "Inicio",
    footer_labs: "Laboratorios",
    footer_leadership: "Liderazgo",
    footer_about: "Sobre Mí",
    footer_privacy: "Política de Privacidad",
    footer_terms: "Términos de Servicio",

    // Generic
    loading: "Cargando...",

    // Upcoming Tech
    ut_upcoming: "Próximamente",
    ut_scroll: "Desliza para Explorar",
    ut_footer: "El Futuro se Construye Aquí.",

    ut_cloud_name: "Moratadeo Cloud",
    ut_cloud_tag: "Infraestructura Serverless Edge",
    ut_cloud_desc: "Un entorno de ejecución globalmente distribuido y autoescalable diseñado para aplicaciones de latencia cero. Despliega código instantáneamente en más de 300 ubicaciones edge sin arranques en frío, con seguridad intrínseca y escalabilidad infinita.",

    ut_db_name: "Moratadeo DB",
    ut_db_tag: "Tejido de Datos Hiper-Consistente",
    ut_db_desc: "La primera base de datos multimodo del mundo con consistencia causal a la velocidad de la luz. Transacciones ACID transregionales, búsqueda vectorial integrada para agentes de IA y un esquema que evoluciona con tu código.",

    // Leadership
    leadership_our: "NUESTRO",
    leadership_team: "EQUIPO.",
    leadership_title: "LIDERAZGO",
    leadership_member: "MIEMBRO_",
    leadership_view_profile: "VER PERFIL ↗",
    leadership_name_label: "NOMBRE",
    leadership_role_label: "ROL",
    leadership_about_label: "ACERCA DE",

    // Leadership Roles & Bios
    leadership_role_ceo: "DIRECTOR EJECUTIVO",
    leadership_bio_ceo: "LIDERANDO LA VISIÓN PARA PRODUCTOS DIGITALES MODERNOS Y EXCELENCIA ARQUITECTÓNICA.",
    leadership_role_coo: "DIRECTORA DE OPERACIONES",
    leadership_bio_coo: "IMPULSANDO LA ESTRATEGIA OPERATIVA Y ASEGURANDO LOS MÁS ALTOS ESTÁNDARES EN LA ENTREGA DE PROYECTOS.",
    leadership_role_hod: "JEFE DE DISEÑO",
    leadership_bio_hod: "DIRIGIENDO LA FILOSOFÍA DE DISEÑO Y CREANDO INTERFACES DE USUARIO DE ALTO RENDIMIENTO.",
  }
};
